import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { UserService } from '../shared/services/user.service';

/**
 * Pages component
 */
@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
})
export class PagesComponent implements OnDestroy {
  companyID = '';

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(userService: UserService) {
    userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe((user) => {
      if (!user) { return; }
      this.companyID = (user.company as any)._id;
    });
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  getCompanyClass() {
    const classes = {};

    if (this.companyID) {
      classes['b2a-company-' + this.companyID] = true;
    }

    return classes;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/pages.component.ts